/* eslint-disable max-statements */
import React from "react";
import PropTypes from "prop-types";
import Arrow from "./images/right-arrow.svg";
import GreyArrow from "./images/arrow-grey.svg";
import DarkGreyArrow from "./images/dark-grey.svg";
import BlueArrow from "./images/blue-arrow.svg";
import DarkBlueArrow from "./images/arrow-dark-blue.svg";
import WhiteArrow from "./images/white-arrow.svg";
import BlackArrow from "./images/arrow-black.svg";
import GreenArrow from "./images/arrow-green.svg";
import YellowArrow from "./images/arrow-yellow.svg";
import LightBlueArrow from "./images/light-blue.svg";
import BackArrow from "./images/arrow-back.svg";
import ArrowBackPrimary from "./images/arrow-back-primary.svg";
import RebrandArrow from "./images/rebrand.svg";

const iconMap = {
    grey: GreyArrow,
    DarkGrey: DarkGreyArrow,
    blue: BlueArrow,
    yellow: YellowArrow,
    white: WhiteArrow,
    black: BlackArrow,
    green: GreenArrow,
    lightBlue: LightBlueArrow,
    darkBlue: DarkBlueArrow,
    backArrow: BackArrow,
    primaryArrow: ArrowBackPrimary,
    rebrand: RebrandArrow
};

const ArrowIcon = ({
    rotateBy,
    width,
    height,
    arrowColor,
    grey,
    DarkGrey,
    blue,
    yellow,
    white,
    black,
    green,
    lightBlue,
    darkBlue,
    backArrow,
    primaryArrow,
    rebrand,
    onClick,
    ...props
}) => {
    const transform = typeof rotateBy === "string" ? rotateBy : `rotate(${rotateBy}deg)`;
    const style = {
        width,
        height,
        transform,
        transition: "all 0.2s ease-in-out 0s"
    };

    let icon = Arrow;

    const iconFlags = {
        grey,
        DarkGrey,
        blue,
        yellow,
        white,
        black,
        green,
        lightBlue,
        darkBlue,
        backArrow,
        primaryArrow,
        rebrand
    };

    icon = Object.keys(iconMap).reduce((acc, key) => {
        return iconFlags[key] ? iconMap[key] : acc;
    }, Arrow);

    // TODO: change arrow color to accept string
    if (arrowColor === "white") {
        icon = WhiteArrow;
    }
    return (
        <img onClick={onClick} src={icon} style={style} alt="arrow icon" {...props} />
    );
};

ArrowIcon.propTypes = {
    rotateBy: PropTypes.any,
    width: PropTypes.number,
    height: PropTypes.number,
    grey: PropTypes.string,
    onClick: PropTypes.func,
    blue: PropTypes.string,
    white: PropTypes.string,
    black: PropTypes.string,
    green: PropTypes.string,
    yellow: PropTypes.string,
    arrowColor: PropTypes.string,
    lightBlue: PropTypes.string,
    darkBlue: PropTypes.string,
    DarkGrey: PropTypes.string,
    backArrow: PropTypes.string,
    primaryArrow: PropTypes.string,
    rebrand: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};

export default ArrowIcon;
